// extracted by mini-css-extract-plugin
export var backgroundImage = "HBOPagePromo-module--background-image--9Bx+8";
export var container = "HBOPagePromo-module--container--inMO4";
export var graphic = "HBOPagePromo-module--graphic--YKkty";
export var section = "HBOPagePromo-module--section--5brx4";
export var text = "HBOPagePromo-module--text--KFDMb";